export default __webpack_public_path__ + "16cb8dbdcdef00ce26e0c94e9ddea53a.jpg";